import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";

const CustomizedgiftswithCompanyBranding = () => {
    const CTAContent = [
        {
          pageName: "Customized Gifts with Company Branding",
          paragraphitalic: "Branding That Speaks for Itself ",
          paragraphText:
                "Raise the stakes for your corporate identity with customized gifts that proudly showcase your company’s logo and message. Whether it's for client appreciation, employee recognition, or promotional giveaways, our branded gifts turn every gesture into a brand statement.",
          ContactFormName: "Customized Gifts with Company Branding",
        },
      ];
    
      const ListPoints = [
        {NogapHeading:" ",
        Sectionparagraph:"",
        RightImgNogap:"../assests/images/customized-gifts/Customized Gifts with Company Branding.jpg",
        Heading:[
            {
                ListHeading:"Personalized Stationery & Office Supplies ",
                ListParagraph:"",
            },
            {
                ListHeading:"Branded Apparel & Accessories",
                ListParagraph:"",
            },
            {
                ListHeading:"Exclusive Corporate Hampers ",
                ListParagraph:""
            }

        ]
        },
        
        
      ]
      
    
  return (
    <>
      <Helmet>
      <title>eYantra Customized Corporate Gifting</title>
      <meta name="description" content="eYantra delivers customized gifts, branded merchandise, joining kits, welcome kits, employee gifts, and personalised business items for every workplace need."/>
      <meta name="keywords" content="eyantra, customized gifts, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees, welcome kits,  employee gifts, personalised business items, "/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      <NoGapContentpoints data={ListPoints[0]}/>
      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        With each customized piece, your brand will be etched in the minds, making sure your company stays top of mind, long after the gift is received.
      </p>
    </>
  );
};

export default CustomizedgiftswithCompanyBranding;
